// Jeu d'icônes de la bibliothèque. SVG en ligne : le lot en compte cinq, en
// tirer une dépendance d'icônes coûterait plus que de les écrire.
//
// N'ont pas suivi la modale : `FilterIcon` (elle repliait « niveau » et
// « notoriété » quand la modale n'avait que 340 px de haut — en pleine page il
// n'y a plus rien à replier, et ces deux filtres n'existent plus), la note de
// musique décorative, la croix de fermeture et les chevrons, tous liés à des
// affordances de modale ou de `<select>` que la refonte a supprimées.
//
// `ClockIcon` est parti avec la refonte de la fiche : elle n'avait qu'un
// consommateur, où elle décorait une durée que le mot « DURÉE » nommait déjà
// juste en dessous.

export function SearchIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    >
      <circle cx="7" cy="7" r="4.5" />
      <path d="M10.5 10.5L14 14" />
    </svg>
  );
}

export function PlayIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" opacity="0.8" aria-hidden="true">
      <path d="M4.5 2.5v11l9-5.5z" />
    </svg>
  );
}

export function ScoreIcon() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M4 2v12M12 1v12" />
      <path d="M4 4.5c2.5-2 5.5-2 8-0.5" />
      <path d="M4 9c2.5-2 5.5-2 8-0.5" />
    </svg>
  );
}

/**
 * Flèche sortante. Ne décore pas : elle annonce qu'un lien quitte Virtuosa,
 * et c'est la seule chose qui distingue visuellement les sorties MuseScore de
 * la navigation interne de la modale.
 */
export function ExternalLinkIcon({ size = 12 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M6.5 3.5H3.5V12.5H12.5V9.5" />
      <path d="M9.5 3.5H12.5V6.5" />
      <path d="M12.5 3.5L7.5 8.5" />
    </svg>
  );
}
